module.exports = __webpack_public_path__ + "static/media/Bulb-icon.45d7c249.svg";